const Report = () =>
  import(/* webpackChunkName: "order-price" */ '@/pages/order/price/index.vue')

export default {
  path: 'price',
  meta: {
    label: 'price',
    auth: 'price'
  },
  component: {
    name: 'Price',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'OrderPriceReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    }
  ]
}
